import {ActionList, VisuallyHidden} from '@primer/react'
import {ArrowRightIcon, EyeClosedIcon} from '@primer/octicons-react'
import {FeaturePreviewLoadingCard} from './components/FeaturePreviewCard'

import tabListStyles from './components/Tabs.module.css'
import {SkeletonText} from '@primer/react/experimental'

export function LoadingDialogMobile() {
  return (
    <ActionList>
      <LoadingActionItem isMobile />
      <LoadingActionItem isMobile />
      <LoadingActionItem isMobile />
      <LoadingActionItem isMobile />
      <LoadingActionItem isMobile />
    </ActionList>
  )
}

function LoadingActionItem(props: {isMobile?: boolean} = {isMobile: false}) {
  return (
    <ActionList.Item aria-busy="true" aria-live="polite">
      <VisuallyHidden>Loading feature preview item</VisuallyHidden>
      <SkeletonText />
      <ActionList.LeadingVisual>
        <EyeClosedIcon />
      </ActionList.LeadingVisual>
      {props.isMobile && (
        <ActionList.TrailingVisual>
          <ArrowRightIcon />
        </ActionList.TrailingVisual>
      )}
    </ActionList.Item>
  )
}

export function LoadingDialogStationary() {
  return (
    <div className={tabListStyles.tabContainer}>
      <ActionList className={tabListStyles.tabList}>
        <LoadingActionItem />
        <LoadingActionItem />
        <LoadingActionItem />
        <LoadingActionItem />
        <LoadingActionItem />
      </ActionList>
      <div className={tabListStyles.tabPanel}>
        <FeaturePreviewLoadingCard />
      </div>
    </div>
  )
}

try{ LoadingDialogMobile.displayName ||= 'LoadingDialogMobile' } catch {}
try{ LoadingActionItem.displayName ||= 'LoadingActionItem' } catch {}
try{ LoadingDialogStationary.displayName ||= 'LoadingDialogStationary' } catch {}